import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// AUTH
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');
export const changePassword = (data) => api.post('/auth/change-password', data);

// FACTORIES
export const getFactories = () => api.get('/factories');
export const createFactory = (data) => api.post('/factories', data);
export const updateFactory = (id, data) => api.put(`/factories/${id}`, data);
export const deleteFactory = (id) => api.delete(`/factories/${id}`);
export const getFactoryUsers = (id) => api.get(`/factories/${id}/users`);

// USERS
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

// PRODUCTS
export const getProducts = (factoryId, includeInactive = false) =>
  api.get(`/factories/${factoryId}/products`, { params: { include_inactive: includeInactive } });
export const createProduct = (factoryId, data) => api.post(`/factories/${factoryId}/products`, data);
export const updateProduct = (factoryId, id, data) => api.put(`/factories/${factoryId}/products/${id}`, data);
export const deleteProduct = (factoryId, id) => api.delete(`/factories/${factoryId}/products/${id}`);

// ENTRIES
export const getEntries = (factoryId, params) => api.get(`/factories/${factoryId}/entries`, { params });
export const getEntry = (factoryId, date) => api.get(`/factories/${factoryId}/entries/${date}`);
export const saveEntry = (factoryId, data) => api.post(`/factories/${factoryId}/entries`, data);
export const deleteEntry = (factoryId, date) => api.delete(`/factories/${factoryId}/entries/${date}`);

// REPORTS
export const getMonthlyReport = (factoryId, year, month) =>
  api.get(`/factories/${factoryId}/reports/monthly`, { params: { year, month } });
export const compareEntries = (factoryId, dates) =>
  api.get(`/factories/${factoryId}/reports/compare`, { params: { dates: dates.join(',') } });
export const getYearlySummary = (factoryId, year) =>
  api.get(`/factories/${factoryId}/reports/yearly-summary`, { params: { year } });
export const getTopProducts = (factoryId, params) =>
  api.get(`/factories/${factoryId}/reports/top-products`, { params });
